import { DataTable } from "@shopify/polaris";
const TargetedProductsTable = ({ headings, columnContentTypes, rows }) => {

  return (
    <DataTable
      truncate
      columnContentTypes={columnContentTypes}
      headings={headings}
      rows={rows}
      sortable={[false, false, false, false, false]}
      defaultSortDirection="descending"
      initialSortColumnIndex={4}
      verticalAlign={"middle"}
      increasedTableDensity
    />
  );
};

export default TargetedProductsTable;